import { useMemo } from "react";

import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";

import type { FrameSender } from "./email-branding-frame.utils";

/**
 * The signed-in staff member as an email's sender, the way the backend fills `{staff_name}` and
 * `{staff_title}` (`get_full_name()` and `role`). For emails sent as this person: New Email,
 * physician email, and touchpoints they create.
 */
export function useCurrentUserFrameSender(): FrameSender {
  const user = useAppSelector(selectCurrentUser);
  const name = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  const title = user?.role ?? "";
  return useMemo(() => ({ name, title }), [name, title]);
}
